import { createAction } from 'redux-actions';
import * as types from './constants';

export const fetchNotificationInfo = createAction(types.NOTIFICATION_INFO_REQUEST);
export const notificationInfoSuccess = createAction(types.NOTIFICATION_INFO_SUCCESS);
export const notificationInfoFailure = createAction(types.NOTIFICATION_INFO_FAILURE);

export const fetchCallInfo = createAction(types.CALL_INFO_REQUEST);
export const callInfoSuccess = createAction(types.CALL_INFO_SUCCESS);
export const callInfoFailure = createAction(types.CALL_INFO_FAILURE);
